import { createContext } from 'react';
import type AppContext from 'types/contexts/AppContext';

export default createContext({} as AppContext);
